import React, { useCallback, useEffect, useState } from 'react';
import TitleHeader from './TitleHeader';
import CredentialPieces from './credentialinputswbuttons';
import { KeyandSecret as KeyAndSecretType } from '../../types/KeyAndSecret';
import { CredentialInfo } from '../../types/credential-info';
import { GetEdfiCredentials } from 'api/credintial-manager-endpoint';
import './keysecretcomponent.css';

const KeySecretComponent: React.FC = () => {
    const [credentials, setCredentials] = useState<KeyAndSecretType>({ Key: '', Secret: '' });
    const unhideimg = '../../resources/imgs/Eye_Icon.png';
    const copyimg = '../../resources/imgs/Colorful_Copy_Icon.png';

    const fetchCredentials = useCallback(async () => {
        try {
            const response = await GetEdfiCredentials();
            console.log('FetchCredentials response:', response); // Log the response
            if (response.success && response.data) {
                setCredentials(response.data);
                console.log('Credentials set:', response.data); // Log the data being set
            } else {
                console.log('FetchCredentials error:', response.message);
            }
        } catch (error) {
            console.error('FetchCredentials exception:', error);
        }
    }, []);

    useEffect(() => {
        fetchCredentials();
    }, [fetchCredentials]);

    useEffect(() => {
        console.log('Credentials updated:', credentials); // Log state updates
    }, [credentials]);

    const key: CredentialInfo = {
        label: 'Key: ',
        id: 'Key',
        value: credentials.Key || '', // Ensure value is always a string
        unhideimgpath: unhideimg,
        copyimgpath: copyimg
    };

    const secret: CredentialInfo = {
        label: 'Secret: ',
        id: 'Secret',
        value: credentials.Secret || '', // Ensure value is always a string
        unhideimgpath: unhideimg,
        copyimgpath: copyimg
    };

    return (
        <div className="flex-container">
            <TitleHeader />
            <div className='flex-item'>
                <CredentialPieces data={key} />
                <CredentialPieces data={secret} />
            </div>
        </div>
    );
};

export default KeySecretComponent;

